export default __webpack_public_path__ + "static/media/simProfile-3.15d64351.png";